import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { EmailNotificationRecipient } from "../../emailNotifications.types";
import { requestAddEmailRecipient } from "./addEmailRecipient.request";

const useAddEmailRecipient = (
  options?: MutationOptions<
    EmailNotificationRecipient,
    ApiServiceError<ApiError>
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestAddEmailRecipient,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["email-notifications", "recipients"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useAddEmailRecipient;
